type Locale = 'en' | 'ru'

const pluralRules = {
  en: new Intl.PluralRules('en'),
  ru: new Intl.PluralRules('ru'),
}

const yearWords: Record<Locale, Record<string, string>> = {
  en: {
    one: 'year',
    other: 'years',
  },
  ru: {
    one: 'год',
    few: 'года',
    many: 'лет',
    other: 'лет',
  },
}

export function formatPluralYears(value: number, locale: Locale = 'en'): string {
  const rule = pluralRules[locale].select(value)
  const word = yearWords[locale][rule]
  return `${value} ${word}`
}
